
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wallet/cash",
      function () {
        return require("private-next-pages/wallet/cash/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wallet/cash"])
      });
    }
  